import React, { Component } from 'react';

import 'bulma/css/bulma.css';
import './styles.scss';
import styles from './App.module.scss';
import "primereact/resources/themes/fluent-light/theme.css";

import { ApiServiceContextProvider } from "./contexts/apiServiceContext";
import { RequestForm } from './components';
import { HeaderBar } from './components';
import { AcquireCaptcha } from './components';

const App = () => {
	const [captchaResult, setCaptchaResult] = React.useState({
		isValid: false,
		count: 0
	});

	const u = new URL(window.location.href);
	const isEmbedded = (u.searchParams.get("embed") === "1");
	return (
		<div className={styles.gsmaMGEARContainer}>
			{!isEmbedded && (
				<HeaderBar
					headerTitle="GSMA Member Gateway Access Request"
					subTitle={"v1.0.14" /* Update version in package.json too */}
				/>
			)}
			<div className="section columns">
				<div className="column is-2">
					<p>&nbsp;</p>
				</div>
				<main className="column">
					{(captchaResult.isValid === false) && (captchaResult.count >= 5) && (
						<h2 className={"title is-4 has-text-danger"} style={{ maxWidth: "600px" }}>
							<span>You've exceeded the maximum number of attempts to prove you're a human, please try again later.</span>
						</h2>
					)}

					{(captchaResult.isValid === false) && (captchaResult.count < 5) && (
						<ApiServiceContextProvider
							serviceName={"managed"}
							type={"managed"}
							autoRefresh={true}
							refreshIntervalMs={60000} // 1 minute
						>
							<AcquireCaptcha
								title="Request to Join Member Gateway"
								subTitle="Before you complete the form to request access to the Member Gateway, you must prove you're a human."
								captchaDigits={6}
								onCaptureStatusChanged={(capctchaStatus) => {
									console.debug(`App.onCaptureStatusChanged()`, capctchaStatus);
									setCaptchaResult(capctchaStatus);
								}}
							/>
						</ApiServiceContextProvider>
					)}

					{(captchaResult.isValid === true) && (
						<ApiServiceContextProvider
							serviceName={"GSMA MGUMS"}
							type={"full"}
							autoRefresh={true}
							refreshIntervalMs={120000} // 2 minutes
						>
							<RequestForm
								title="Request to Join Member Gateway"
								subTitle="Fill in your details below and a request will be sent to your organisation's <b>MIM</b> to invite you to join the Member Gateway."
								inactivityTimeoutMs={10 * 60 * 1000} // 10 minutes = 600000ms
								onFormInactivityTimeout={() => {
									console.debug(`App:onFormTimeout() ➜ resetting captcha state`);
									setCaptchaResult({
										isValid: false,
										count: 0
									});
								}}
							/>
						</ApiServiceContextProvider>
					)}
				</main>
			</div>
		</div>
	);
};

export default App;
